import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    tabsContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: 0,
        backgroundColor: theme.palette.type === 'dark' ? '#1F2937' : '#F3F4F6',
        borderRadius: 12,
        padding: 4,
        marginBottom: theme.spacing(3),
        width: 'fit-content',
        flexWrap: 'wrap'
    },
    tab: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        padding: theme.spacing(1.25, 3),
        borderRadius: 10,
        cursor: 'pointer',
        fontSize: 15,
        fontWeight: 500,
        color: theme.palette.text.secondary,
        backgroundColor: 'transparent',
        border: 'none',
        transition: 'all 0.2s ease',
        '&:hover': {
            backgroundColor: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)'
        }
    },
    activeTab: {
        backgroundColor: theme.palette.type === 'dark' ? '#374151' : '#FFFFFF',
        color: theme.palette.type === 'dark' ? '#FFFFFF' : theme.palette.primary.main,
        boxShadow: theme.palette.type === 'dark'
            ? '0 2px 8px rgba(0,0,0,0.3)'
            : '0 2px 8px rgba(0,0,0,0.08)',
        fontWeight: 600
    },
    tabIcon: {
        fontSize: 20
    }
}));

/**
 * GlobalTabs - A reusable tab component
 * 
 * @param {Array} tabs - Array of tab objects: [{ id: string, label: string, icon?: Component }]
 * @param {string} activeTab - Currently active tab id
 * @param {Function} onChange - Callback when tab changes: (tabId) => void
 * @param {string} className - Optional additional class for container
 */
function GlobalTabs({ tabs, activeTab, onChange, className = '' }) {
    const classes = useStyles();

    return (
        <div className={`${classes.tabsContainer} ${className}`}>
            {tabs.map((tab) => {
                const IconComponent = tab.icon;
                return (
                    <button
                        key={tab.id}
                        className={`${classes.tab} ${activeTab === tab.id ? classes.activeTab : ''}`}
                        onClick={() => onChange(tab.id)}
                    >
                        {IconComponent && <IconComponent className={classes.tabIcon} />}
                        {tab.label}
                    </button>
                );
            })}
        </div>
    );
}

export default GlobalTabs;